import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { backendDomain } from "../utils";
import universe from "../images/project-giphy.gif";
import Chip from "@mui/material/Chip";
import FrostedCard from "./FrostedCard";

const MainContainer = styled.div`
  height: 100%;
  min-height: 100vh;
`;

const ContentContainer = styled.div`
  margin-top: 83px;
  margin-left: 60px;
  margin-right: 60px;
`;

const PageTitle = styled.div`
  font-size: 2rem;
  font-weight: bold;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PageSubTitle = styled.div`
  font-size: 1rem;
  padding-bottom: 5rem;
`;

// Custom styled CardContent with black background and white font color
const CustomCardContent = styled(CardContent)`
  background-color: black;
  color: white;

  transition: background-color 0.3s ease;
  &:hover {
    cursor: pointer;
    background-color: grey;
  }
`;

const CustomCardActions = styled(CardActions)`
  background-color: black;
  color: white;
`;

const BlogLandingPage = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(`${backendDomain()}/blog/all`);
        const data = await response.json();

        // Transform the data into an array
        const postsArray = Object.entries(data).map(([slug, post]) => ({
          slug,
          ...post,
        }));
        // sort by ID
        postsArray.sort((a, b) => {
          return b.data.id - a.data.id;
        });

        setPosts(postsArray);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };

    fetchPosts();
  }, []);

  const readMoreHandler = (blog) => {
    navigate(`/blog/${blog.slug}`);
  };

  const Paragraph = styled.div`
    margin-bottom: 1rem;

    margin-left: auto;
    margin-right: auto;
    max-width: 50rem;
    font-size: 1.125rem;
    line-height: 150%;
    font-weight: 400;
    font-family: sans-serif;
  `;

  return (
    <MainContainer>
      <ContentContainer>
        <PageTitle>
          <Paragraph>
            Welcome to the place where I share my thoughts and lessons on
            technology, stories, takeaways, and life. If even one person finds
            inspiration or learns something from my writing, it would mean the
            world to me. Let’s learn, grow, and connect—one post at a time!
          </Paragraph>
        </PageTitle>
        {posts.length > 0 ? (
          <div style={{ margin: "3rem 0 4rem 0" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                gap: "2.5rem",
              }}
            >
              {posts.map((post) => {
                const imgSrc = post.data.thumbnail || universe;
                const isGif = imgSrc.endsWith(".gif");
                return (
                  <FrostedCard
                    key={post.slug}
                    image={imgSrc}
                    isGif={isGif}
                    title={post.data.title}
                    subtitle={post.data.subtitle}
                    chips={post.data.chips}
                    meta={`Date: ${post.data.date} | Author: Chenyu Zhang`}
                    credit={post.data.thumbnail_credit}
                    onClick={() => readMoreHandler(post)}
                  />
                );
              })}
            </div>
          </div>
        ) : (
          <div
            style={{
              textAlign: "center",
              color: "#b3b3b3",
              fontSize: "1.2rem",
              margin: "4rem 0",
            }}
          >
            loading...
          </div>
        )}
      </ContentContainer>
    </MainContainer>
  );
};

export default BlogLandingPage;
